export const remindersRouteNames = {
  default:'reminders-v2'
}
